module.exports = __webpack_public_path__ + "static/media/atechsyn.300da924.png";